import {
  nextNCSPosition,
  previousNCSPosition,
  backNCSPosition,
  nextNCSLevel
} from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base { /* USED BY MIDI CONTROLLER */

    track_load(_deckid) {
      window.dispatchEvent(new KeyboardEvent('keydown', {key: _deckid === 1 ? 'ArrowLeft' : 'ArrowRight', shiftKey: true}));
      window.dispatchEvent(new KeyboardEvent('keyup', {key:  _deckid === 1 ? 'ArrowLeft' : 'ArrowRight', shiftKey: true}));
    }
    track_rotary_select() { store.dispatch(nextNCSLevel()) }
    track_back() { store.dispatch(backNCSPosition()) }
    track_rotary_back_or_select() {
      const state = store.getState();
      if (state.NCState) {
        const [,,action] = state.NCState.current;
        (state.NCState.current && (action === `click` || !action)) && store.dispatch(backNCSPosition());
        (state.NCState.current && action === `class`) && store.dispatch(nextNCSLevel());
      }
    }
    track_select(_direction) {
      (_direction === 1) && store.dispatch(nextNCSPosition());
      (_direction === -1) && store.dispatch(previousNCSPosition());
    }

  }
  return NewRoot;
}

export default Root;
